import { render, staticRenderFns } from "./subsidiary_admin.vue?vue&type=template&id=67ae7d63"
import script from "./subsidiary_admin.vue?vue&type=script&lang=js"
export * from "./subsidiary_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports